export interface IUser {
  name: string;
  authenticated: boolean;
  roles?: string[];
  lastAuthenticated?: number;
  canMintApiTokens?: boolean;
  isAdmin?: boolean;
}

const defaultUser: IUser = {
  name: '[anonymous]',
  roles: [],
  authenticated: false,
  canMintApiTokens: false,
  isAdmin: false,
};

export class AuthenticationService {
  private static user: IUser = { ...defaultUser };

  private static authEvents: Function[] = [];

  public static getAuthenticatedUser(): IUser {
    return { ...this.user };
  }

  public static setAuthenticatedUser(authenticatedUser: IUser): void {
    if (authenticatedUser && authenticatedUser.name) {
      this.user.name = authenticatedUser.name;
      this.user.authenticated = true;
      this.user.lastAuthenticated = new Date().getTime();
      this.user.roles = authenticatedUser.roles;
      this.user.canMintApiTokens = authenticatedUser.canMintApiTokens ?? false;
      this.user.isAdmin = authenticatedUser.isAdmin ?? false;
    }

    this.authEvents.forEach((event: Function) => {
      try {
        event();
      } catch (error) {
        console.error('Authentication listener failed', error);
      }
    });
  }

  public static onAuthentication(event: Function): () => void {
    this.authEvents.push(event);
    return () => {
      this.authEvents = this.authEvents.filter((registeredEvent) => registeredEvent !== event);
    };
  }

  public static authenticationExpired(): void {
    this.user.authenticated = false;
  }

  public static reset(): void {
    this.user = { ...defaultUser };
  }
}
